<script>
import { CITY, COUNTRY_CODE, AREA_CODE } from '@src/config/location'
import { JOB_CATEGORY, POSITION, COMPANY_INDUSTRY, COMPANY_SIZE, ROLE, ISSUE_INTEREST } from '@src/config/company'
import _find from 'lodash/find'
import DialogPrivacy from '@components/Dialog/Privacy'
import DialogProtection from '@components/Dialog/Protection'
import { authComputed } from '@store/helpers'
import CountryCodePicker from '@components/Input/CountryCodePicker'
import ValidDialog from '@components/Dialog/ValidDealer.vue'
// import { mapState } from 'vuex'

export default {
  components: {
    DialogPrivacy,
    DialogProtection,
    CountryCodePicker,
    ValidDialog,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
    multiMail: {
      type: Boolean,
      default: false,
    },
    noVat: {
      type: String,
      default: 'none',
    },
    // onLock: {
    //   type: Boolean,
    //   default: false,
    // },
    fixedBottom: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => {
        return [
          {
            col: 12, // 1 - 12
            type: 'text', // 必填 [ text, textarea, select, radio, checkbox, city:縣市, district:行政區, countryCode:國碼, areaCode:區碼, font:純文字, null, hr, agree:同意條款 ]
            label: '姓名',
            placeholder: 'placeholder',
            name: 'name', // 必填
            rules: 'require', // vee-validate
            description: '', // Support HTML
            font: '', // type: font 必填
            options: [
              // type: select 必填
              {
                text: 'text',
                value: 'value',
              },
            ],
            phones: [
              {
                phoneCode: '',
                phone: '',
                ext: '',
              },
            ],
            domainOptions: [
              {
                email: '',
                domain: '',
              },
            ],
            isHiddenLabel: false, // 消失
            isTransparentLabel: false, // 透明
            disabled: false,
            rulesName: '',
          },
        ]
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: '清除重填',
    },
    confirmText: {
      type: String,
      default: '確定送出',
    },
    type: {
      type: String,
      default: 'type',
    },
    buttonStyle: {
      type: String,
      default: 'isStylePrimary isSmall isRadius isOutline2',
    },
    buttonStyle2: {
      type: String,
      default: 'isStylePrimary isSmall isRadius',
    },
    buttonStyle3: {
      type: String,
      default: 'isStylePrimary isSmall isRadius isOutline2',
    },
  },
  data() {
    return {
      isDialogPrivacyVisible: false,
      isDialogProtectionVisible: false,
      isDialogValidVisible: false,
      company: {
        name: '',
        phone: '',
      },
      isHasVat: false,
      isCheckVat: false,
      errorEmail: false,
      domainType: 'free',
      isMobile: false,
      copyEmail: false,
    }
  },
  computed: {
    ...authComputed,
    data: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    cityOpition() {
      return CITY.map((item) => {
        return {
          text: item.name,
          value: item.name,
        }
      })
    },
    districtOpition() {
      const { districts } = _find(CITY, { name: this.data.city }) || { districts: [] }
      return districts.map((item) => {
        return {
          text: `${item.zip} ${item.name}`,
          value: `${item.zip} ${item.name}`,
        }
      })
    },
    countryCodeOpition() {
      return COUNTRY_CODE.map((item) => {
        return {
          text: `${item.code} (${item.country})`,
          value: '+' + item.code,
        }
      })
    },
    areaCodeOpition() {
      return AREA_CODE.map((item) => {
        return {
          text: `${item.code} (${item.area})`,
          value: item.code,
        }
      })
    },
    jobCategoryOpition() {
      return JOB_CATEGORY.map((item) => {
        return {
          text: item.text,
          value: item.value,
        }
      })
    },
    positionOpition() {
      return POSITION.map((item) => {
        return {
          text: item.text,
          value: item.value,
        }
      })
    },
    companyIndustryOpition() {
      return COMPANY_INDUSTRY.map((item) => {
        return {
          text: item.text,
          value: item.value,
        }
      })
    },
    companySizeOpition() {
      return COMPANY_SIZE.map((item) => {
        return {
          text: item.text,
          value: item.value,
        }
      })
    },
    roleOpition() {
      return ROLE.map((item) => {
        return {
          text: item.text,
          value: item.value,
        }
      })
    },
    faxCodeOption() {
      const result = [
        {
          text: '手機',
          value: '+886',
        },
        ...AREA_CODE.map((item) => {
          return {
            text: `${item.code} (${item.area})`,
            value: item.code,
          }
        }),
      ]
      return result
    },
    isIssueHasOtehr() {
      const result = this.value.companyinterestedIssue.some((item) => {
        return item === '其他'
      })
      // if(result) {
      //   this.$nextTick(() => {
      //     this.$refs['issueHasOther'].focus();
      //   })
      // }
      return result
    },
    issueInterstOpition() {
      return ISSUE_INTEREST.map((item) => {
        return {
          text: item.text,
          value: item.value,
        }
      })
    },
  },
  created() {
    const vm = this
    if (window.location.pathname.includes('contact')) {
      this.stateLock(false)
    } else {
      this.stateLock(true)
    }
    const mobile = window.innerWidth
    if (mobile < 576) vm.isMobile = true

    if (this.data.email === this.data.companyemail) this.copyEmail = true
  },
  methods: {
    onSubmit() {
      this.isDialogValidVisible = false
      this.$emit('submit')
    },
    onCancel() {
      this.$emit('cancel')
    },
    onChangeCity() {
      this.$set(this.data, 'district', '')
    },
    resetFields() {
      this.$refs.form.resetFields()
    },
    checkFieldDisplayRule(field) {
      return !field.displayRule || typeof field.displayRule !== 'function' || (typeof field.displayRule === 'function' && field.displayRule() === true)
    },
    async tryToCheckVat(vat) {
      this.$emit('vat', vat)
    },
    addPhone() {
      // this.$emit('phone')
      this.data.companyphones.push({
        phoneCode: '',
        phone: '',
        ext: '',
      })
    },
    deletePhone(index) {
      this.data.companyphones.splice(index, 1)
    },
    addFreeEmail() {
      this.$emit('freeEmail')
    },
    changeDomainType() {
      this.$emit('resetEmail')
    },
    testEmail(value, mailtype) {
      const vm = this
      const emailRegxp = /^([\w]+)(.[\w]+)*@([\w]+)(.[\w]{2,3}){1,2}$/
      const domainRegxp = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
      if (mailtype === 'free') {
        if (emailRegxp.test(value) !== true || !value) {
          vm.errorEmail = true
        } else {
          vm.errorEmail = false
        }
      } else {
        if (domainRegxp.test(value) !== true || !value) {
          vm.errorEmail = true
        } else {
          vm.errorEmail = false
        }
      }
    },
    stateLock(value) {
      this.$store.dispatch('auth/setLock', value)
      if (this.data.email === this.data.companyemail) this.copyEmail = true
    },
    editUserInfo() {
      this.stateLock(false)
      this.copyEmail = false
    },
    testtoto() {
      const tobeDealer = true
      this.$router.push({
        name: 'inquiryOther',
        params: { tobeDealer },
      })
    },
    levelUp() {
      this.isDialogValidVisible = false
      this.$emit('levelUp')
    },
    copyCompanyEmail() {
      this.data.email = this.data.companyemail
    },
    changeCompanyEmail(value) {
      if (this.copyEmail) this.data.email = value
    },
  },
}
</script>
<template>
  <div :class="$style.baseForm">
    <ValidationObserver v-slot="{ invalid, handleSubmit }">
      <el-form ref="form" :model="data" class="isStyleBase" :disabled="onLock" label-position="top" @submit.prevent.native="handleSubmit(onSubmit)">
        <div class="row">
          <template v-for="(item, index) in list">
            <div v-if="checkFieldDisplayRule(item)" :key="`item-${index}`" :class="`col-md-${item.col || 12}`">
              <ValidationProvider
                v-if="item.type !== 'null' && item.type !== 'font' && item.type !== 'hr' && item.type !== 'agree'"
                v-slot="{ errors }"
                :name="item.rulesName || item.label"
                :rules="onLock ? '' : item.rules"
                :debounce="item.debounce || 0"
                :immediate="item.immediate"
              >
                <el-form-item
                  :label="item.label"
                  :error="errors[0]"
                  :prop="item.name"
                  :class="{ isTransparentLabel: item.isTransparentLabel, isHiddenLabel: item.isHiddenLabel, isRequire: onLock ? '' : (item.rules || '').indexOf('require') !== -1 }"
                >
                  <!-- add-phone -->
                  <template v-if="item.type === 'addPhone'">
                    <span v-for="(innerItem, innerIndex) of data[item.name]" :key="innerIndex">
                      <div :style="onLock ? 'background-color:#f5f7fa' : 'background-color:white'" class="row align-items-center" style="margin: 0; padding: 25px 0px">
                        <div class="col-md-1" style="font-size: 1.125em; color: #525a67; padding-right: 0px; padding-left: 10px">電話{{ innerIndex + 1 }}:</div>
                        <!--areaCode-->
                        <div class="col-md-3">
                          <el-select v-model="innerItem.phoneCode" placeholder="區碼" filterable clearable>
                            <el-option v-for="(option, index2) in areaCodeOpition" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled">
                            </el-option>
                          </el-select>
                        </div>
                        <div class="col-md-5">
                          <el-input v-model.number="innerItem.phone" type="number" placeholder="室內電話格式：xxxxxxxx" clearable></el-input>
                        </div>
                        <div class="col-md-2">
                          <el-input v-model.number="innerItem.ext" type="number" placeholder="分機" clearable></el-input>
                        </div>
                        <div class="col-md-1"><i class="el-icon-close" style="cursor: pointer; color: #b1baca" @click="deletePhone(innerIndex)"></i></div>
                      </div>
                    </span>
                    <BaseButton v-if="!onLock" class="w-100 mt-3" :class="buttonStyle3" @click="addPhone"> +新增電話 </BaseButton>
                  </template>
                  <!--text-->
                  <template v-if="item.type === 'text'">
                    <el-input
                      v-if="item.name === 'companyvat'"
                      v-model="data[item.name]"
                      :placeholder="item.placeholder"
                      :disabled="item.disabled"
                      :class="{ errorborder: noVat === 'fail', successborder: noVat === 'success' }"
                      clearable
                      @input="tryToCheckVat(data[item.name])"
                    >
                      <template v-if="noVat === 'fail'" slot="suffix">
                        <span style="color: #cd0202; font-size: 16px; margin-right: 10px"> <i class="el-icon-warning-outline"></i>驗證失敗 </span></template
                      >
                      <template v-else-if="noVat === 'success'" slot="suffix">
                        <span style="color: #abcd03; font-size: 16px; margin-right: 10px"> <i class="el-icon-check"></i>驗證成功 </span></template
                      >
                    </el-input>
                    <el-input v-else v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" clearable></el-input>
                    <template v-if="item.name === 'companyvat' && noVat === 'fail'">
                      <div class="mt-2 registered__notice"
                        >若想成為經銷公司，
                        <span class="color-primary" style="text-decoration: underline; cursor: pointer" @click="testtoto">請至會員帳號服務</span>
                      </div>
                    </template>
                  </template>
                  <!--textarea-->
                  <template v-if="item.type === 'textarea'">
                    <el-input v-model="data[item.name]" type="textarea" :autosize="{ minRows: 6, maxRows: 6 }" :placeholder="item.placeholder" :disabled="item.disabled"></el-input>
                  </template>
                  <!--select-->
                  <template v-if="item.type === 'select'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable>
                      <el-option v-for="(option, index2) in item.options || []" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled"> </el-option>
                    </el-select>
                  </template>
                  <!--radio-->
                  <template v-if="item.type === 'radio'">
                    <el-radio-group v-model="data[item.name]">
                      <el-radio v-for="(option, index2) in item.options || []" :key="`option-${index}-${index2}`" :label="option.value">
                        {{ option.text }}
                      </el-radio>
                    </el-radio-group>
                  </template>
                  <!--checkbox-->
                  <template v-if="item.type === 'checkbox'">
                    <el-checkbox-group v-model="data[item.name]" :disabled="item.disabled">
                      <el-checkbox v-for="(option, index2) in item.options || []" :key="`option-${index}-${index2}`" :label="option.text" :disabled="option.disabled"> {{ option.text }} </el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <!--email -->
                  <template v-if="item.type === 'email'">
                    <BaseEmail :ref="item.name" v-model="data[item.name]" :placeholder="item.placeholder" />
                  </template>
                  <!-- company email -->
                  <template v-if="item.type === 'companyEmail' && multiMail === false">
                    <BaseEmail :ref="item.name" v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" @changeCompanyEmail="changeCompanyEmail" />
                  </template>
                  <!-- personal email -->
                  <template v-if="item.type === 'personalEmail' && multiMail === false">
                    <BaseEmail :ref="item.name" v-model="data[item.name]" :placeholder="item.placeholder" :disabled="copyEmail" />
                  </template>
                  <!--city-->
                  <template v-if="item.type === 'city'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable @change="onChangeCity">
                      <el-option v-for="(option, index2) in cityOpition" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled"> </el-option>
                    </el-select>
                  </template>
                  <!--district-->
                  <template v-if="item.type === 'district'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable no-data-text="請選擇縣市">
                      <el-option v-for="(option, index2) in districtOpition" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled"> </el-option>
                    </el-select>
                  </template>
                  <!--faxCode-->
                  <template v-if="item.type === 'faxCode'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable>
                      <el-option v-for="(option, index2) in faxCodeOption" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled"> </el-option>
                    </el-select>
                  </template>
                  <!--areaCode-->
                  <template v-if="item.type === 'areaCode'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable>
                      <el-option v-for="(option, index2) in areaCodeOpition" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled"> </el-option>
                    </el-select>
                  </template>
                  <!-- jobCategory -->
                  <template v-if="item.type === 'jobCategroy'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable no-data-text="請選擇">
                      <el-option v-for="(option, index2) in jobCategoryOpition" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled"> </el-option>
                    </el-select>
                  </template>
                  <!-- positionOpition -->
                  <template v-if="item.type === 'position'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable no-data-text="請選擇">
                      <el-option v-for="(option, index2) in positionOpition" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled"> </el-option>
                    </el-select>
                  </template>
                  <!-- companyIndustryOpition -->
                  <template v-if="item.type === 'companyIndustry'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable no-data-text="請選擇">
                      <el-option v-for="(option, index2) in companyIndustryOpition" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled">
                      </el-option>
                    </el-select>
                  </template>
                  <!-- companySize -->
                  <template v-if="item.type === 'companySize'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable no-data-text="請選擇">
                      <el-option v-for="(option, index2) in companySizeOpition" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled"> </el-option>
                    </el-select>
                  </template>
                  <!-- role -->
                  <template v-if="item.type === 'role'">
                    <el-select v-model="data[item.name]" :placeholder="item.placeholder" :disabled="item.disabled" filterable clearable no-data-text="請選擇">
                      <el-option v-for="(option, index2) in roleOpition" :key="`option-${index}-${index2}`" :label="option.text" :value="option.value" :disabled="option.disabled"> </el-option>
                    </el-select>
                  </template>
                  <!-- interestedIssue -->
                  <template v-if="item.type === 'companyinterestedIssue'">
                    <el-checkbox-group v-model="data[item.name]">
                      <div class="row mobileGutter">
                        <div v-for="(innerItem, $index) in issueInterstOpition" :key="$index" class="col-6 mb-md-3 mb-2">
                          <el-checkbox :label="innerItem.text" name="interestedIssue" :class="{ smallFont: isMobile === true }" class="w-100 isFullBorder" border> </el-checkbox>
                        </div>
                      </div>
                    </el-checkbox-group>
                  </template>
                  <!-- account-phone -->
                  <template v-if="item.type === 'mobilePhone'">
                    <el-input v-model="data.mobilePhone" disabled>
                      <CountryCodePicker slot="prepend" v-model="data.mobilePhoneCode" disabled class="isStyleForm" />
                    </el-input>
                  </template>
                  <!-- phoneCode -->
                  <template v-if="item.type === 'mobilePhoneCode'">
                    <CountryCodePicker v-model="data.mobilePhoneCode" class="isStyleForm" />
                  </template>
                  <!-- backupMobilePhone -->
                  <template v-if="item.type === 'backupMobilePhone'">
                    <el-input v-model="data.backupMobilePhone" :disabled="item.disabled">
                      <!-- <CountryCodePicker slot="prepend" v-model="data.backupMobilePhoneCode" :disabled="onLock ? true : false" class="isStyleForm" /> -->
                    </el-input>
                  </template>
                  <template v-if="item.type === 'hr'">
                    <hr style="margin-top: 1rem" />
                  </template>
                  <!-- add-domain -->
                  <template v-if="item.type === 'email' && multiMail === true">
                    <el-radio v-model="domainType" label="free" border class="isBlockStyle" @change="changeDomainType"> 免費電子郵件<span style="color: #8c97ac">(例：yahoo、gmail)</span> </el-radio>
                    <div v-if="domainType === 'free'">
                      <template v-if="item.type === 'email'">
                        <div style="margin: 0; margin-bottom: 10px; background-color: white; padding: 24px">
                          <span v-for="(innerItem, innerIndex) of item.domainOptions" :key="innerIndex">
                            <div class="row align-items-center" style="padding: 5px">
                              <div class="col-md-2" style="font-size: 1.125em; color: #525a67">電子郵件 {{ innerIndex + 1 }}:</div>
                              <div class="col-md-10">
                                <el-input
                                  v-model="innerItem.email"
                                  placeholder="請填寫完整信箱，例：123@gmail.com"
                                  clearable
                                  :class="{ 'is-error-mail': errorEmail === true }"
                                  @input="
                                    (val) => {
                                      testEmail(val, 'free')
                                    }
                                  "
                                ></el-input>
                              </div>
                            </div>
                          </span>
                          <BaseButton class="w-100 mt-3" :class="buttonStyle" @click="addFreeEmail"> +新增電子郵件 </BaseButton>
                        </div>
                      </template>
                    </div>
                    <el-radio v-model="domainType" label="myself" border class="isBlockStyle" @change="changeDomainType"> 自有網域電子郵件 </el-radio>
                    <div v-if="domainType === 'myself'">
                      <template v-if="item.type === 'email'">
                        <div style="margin: 0; margin-bottom: 10px; background-color: white; padding: 24px">
                          <span v-for="(innerItem, innerIndex) of item.domainOptions" :key="innerIndex">
                            <div class="row align-items-center" style="padding: 5px">
                              <div class="col-md-2" style="font-size: 1.125em; color: #525a67">網域 {{ innerIndex + 1 }}:</div>
                              <div class="col-md-10">
                                <el-input
                                  v-model="innerItem.domain"
                                  placeholder="請填寫網域名稱，例：123.com"
                                  clearable
                                  :class="{ 'is-error-mail': errorEmail === true }"
                                  @input="
                                    (val) => {
                                      testEmail(val, 'domain')
                                    }
                                  "
                                ></el-input>
                              </div>
                            </div>
                          </span>
                          <BaseButton class="w-100 mt-3" :class="buttonStyle" @click="addFreeEmail"> +新增網域 </BaseButton>
                        </div>
                      </template>
                    </div>
                    <div v-if="errorEmail === true" class="el-form-item__error"> 請填寫正確'email' </div>
                  </template>
                  <div v-if="item.description" style="margin-top: 0.5rem; line-height: 1.5" class="color-gray-6" v-html="item.description">
                    {{ item.description }}
                  </div>
                </el-form-item>
              </ValidationProvider>
              <!-- 為了不在validationProvider裡，才拉到這裡。只有個人信箱才有"同公司信箱"的功能 -->
              <template v-if="item.type === 'personalEmail'">
                <el-checkbox v-model="copyEmail" style="color: #b1bacd; position: absolute; top: 4px; left: 4%; margin: 0px 5px 0px 95px" @change="copyCompanyEmail">同公司信箱</el-checkbox>
              </template>
              <template v-if="item.type === 'companyinterestedIssue'">
                <el-input
                  ref="issueHasOther"
                  v-model="data.companyissueOther"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  placeholder="請輸入其他感興趣議題"
                  :disabled="!isIssueHasOtehr"
                  class="mb-4"
                >
                </el-input>
              </template>
              <template v-if="item.type === 'font'">
                <div class="el-form-item">
                  <div class="el-form-item__label">{{ item.label }}</div>
                  <div class="mt-3 color-gray-6">
                    {{ item.font }}
                  </div>
                </div>
              </template>
              <template v-if="item.type === 'newsletter'">
                <!-- <div class="baseForm__newsletter bg-white text-center">
                  <p class="">零壹電子報</p>
                  <p class="text-gray-5" style="font-size: .85rem">
                    零壹電子報為雙周發刊，提供最新代理品牌新訊、解決方案、優惠促銷與原廠認證課 程活動訊息。
                  </p>
                  <BaseButton
                    class="isSmall py-3 px-5 mt-4"
                    :class="{ 'isStylePrimary': !data[item.name] }"
                    @click="data[item.name] = !data[item.name]"
                  >
                    <template v-if="data[item.name]">
                      取消訂閱
                    </template>
                    <template v-else>
                      開始訂閱
                    </template>
                  </BaseButton>
                </div> -->

                <el-form-item prop="newsletters">
                  <div class="baseForm__newsletter">
                    <p style="font-size: 1.125em; color: #525a67">您的電子報</p>
                    <div v-if="!isDealer" class="mb-4">
                      <div class="align-items-center d-flex mb-2">
                        <el-switch v-model="data.subscribeNewsletter" active-color="#ABCD03"></el-switch>
                        <span class="newsletters__title">零壹電子報</span>
                      </div>
                      <p class="my-0 newsletters__description">
                        零壹電子報，雙週發刊，提供最新零壹科技代理品牌訊息、最佳優惠的促銷資訊及專業完整教育課程資訊，此外，更多的活動更是您所不能錯過的喔！請立即完成訂閱流程，即享零壹電子報服務。</p
                      >
                    </div>
                    <div v-else>
                      <div class="align-items-center d-flex mb-2">
                        <el-switch v-model="data.subscribeNewsletter" active-color="#ABCD03"></el-switch>
                        <span class="newsletters__title">零壹經銷報</span>
                        <span class="badge isOutline ml-2">經銷商限定</span>
                      </div>

                      <p class="my-0 newsletters__description"> 零壹好康報，即時提供零壹科技最新的促銷優惠資訊、研討會活動及教育訓練課程等資訊，請立即完成訂閱流程，即享零壹好康報服務。</p>
                    </div>
                  </div>
                </el-form-item>
              </template>
              <template v-if="item.type === 'hr'">
                <hr style="margin-top: -1rem" />
              </template>
              <template v-if="item.type === 'agree'">
                <div class="mb-2">
                  送出資料及代表同意
                  <BaseButton class="isStylePrimary isTextUnderline" @click="isDialogPrivacyVisible = true"> 會員權益及隱私權聲明 </BaseButton>
                </div>
                <div>
                  送出資料及代表同意
                  <BaseButton class="isStylePrimary isTextUnderline" @click="isDialogProtectionVisible = true"> 零壹科技保有您的個人資訊 </BaseButton>
                </div>
              </template>
            </div>
          </template>
          <!-- v-for template -->
        </div>
        <hr />
        <div v-if="fixedBottom" class="bottom-fixed">
          <div class="row justify-content-center">
            <div :class="[isMobile ? 'col-8' : 'col-4', isMobile ? 'mb-2' : '']">
              <BaseButton
                class="w-100"
                :class="buttonStyle3"
                :to="{
                  name: 'inquiryOther',
                  params: { phone: 'phone' },
                }"
              >
                申請變更手機號碼
              </BaseButton>
            </div>
            <template v-if="!onLock">
              <div :class="isMobile ? 'col-8' : 'col-4'">
                <template v-if="currentMember.group === '一般會員'">
                  <BaseButton class="w-100" :class="buttonStyle2" :disabled="noVat !== 'success' && invalid" :loading="loading" @click="onSubmit"> 儲存修改 </BaseButton>
                </template>
                <!-- <template v-else-if="noVat !== 'success'">
                  <BaseButton class="w-100" :class="buttonStyle2" :loading="loading" @click="stateLock(true)"> 關閉修改 </BaseButton>
                </template> -->
                <template v-else>
                  <template v-if="currentMember.group === '經銷會員'">
                    <BaseButton class="w-100" :class="buttonStyle2" :disabled="invalid" :loading="loading" @click="onSubmit"> 儲存修改 </BaseButton>
                  </template>
                  <template v-else>
                    <BaseButton class="w-100" :class="buttonStyle2" :disabled="invalid" :loading="loading" @click="isDialogValidVisible = true"> 儲存修改 </BaseButton>
                  </template>
                </template>
              </div>
            </template>
            <template v-else>
              <div :class="isMobile ? 'col-8' : 'col-4'">
                <BaseButton class="w-100" :class="buttonStyle2" @click="editUserInfo"> 編輯 </BaseButton>
              </div>
            </template>
          </div>
          <ValidDialog :visible.sync="isDialogValidVisible" :dialog-data="dialogData" @nowLevelUp="levelUp" @notNow="$emit('notNow')" />
        </div>
        <div v-else class="row mt-5">
          <div v-if="cancelText" class="col-md">
            <BaseButton class="w-100" :class="buttonStyle" @click="onCancel"> {{ cancelText }} </BaseButton>
          </div>
          <div v-if="confirmText" class="col-md mt-3 mt-md-0">
            <BaseButton v-if="!multiMail" type="submit" :disabled="invalid" :loading="loading" class="w-100" :class="buttonStyle"> {{ confirmText }} </BaseButton>
            <BaseButton v-else-if="multiMail" type="submit" :disabled="invalid || errorEmail" :loading="loading" class="w-100" :class="buttonStyle"> {{ confirmText }} </BaseButton>
          </div>
        </div>
      </el-form>
    </ValidationObserver>
    <DialogPrivacy :visible.sync="isDialogPrivacyVisible" />
    <DialogProtection :visible.sync="isDialogProtectionVisible" />
  </div>
</template>
<style lang="scss" module>
.baseForm {
  :global {
    .baseForm {
      &__newsletter {
        padding: 40px;
        background: #fff;
        .newsletters {
          &__title {
            margin: 0 15px;
            font-size: 1.25em;
            font-weight: 500;
          }

          &__description {
            margin-left: 3.45rem;
            font-size: 1.125em;
            color: #525a67;
          }
        }

        @include max-md {
          padding: $container-gap;
          background: $color-gray-2;
        }

        // @include max-sm {
        //   padding: 25px 50px;
        // }
      }
    }
    .bottom-fixed {
      position: fixed;
      bottom: 0;
      left: 0%;
      width: 100%;
      height: 95px;
      background-color: #ffffff;
      box-shadow: 0px -3px 6px #0000000f;
      z-index: 5;
      padding-top: 19px;
      @include max-md {
        bottom: 15%;
        height: 134px;
      }
      @include max-sm {
        height: 136px;
      }
    }
    .is-error-mail > .el-input__inner {
      border-color: #f56c6c !important;
    }
    .successborder > input {
      border: 1px solid #abcd03 !important;
    }
    .errorborder > input {
      border: 1px solid #f56c6c !important;
      background-color: #cd020208;
    }
    .el-input-group__prepend,
    .el-input-group__append {
      display: table-cell !important;
      padding: 0 !important;
    }
    .isStyleField {
      width: 110% !important;
    }
    .baseButton:disabled {
      background: #f5f7fa !important ;
      border: 1px solid #e4e7ed !important;
      color: #c0c4cc !important;
      opacity: 1 !important;
    }
    .smallFont {
      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        font-size: 0.75rem;
      }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }
    /* 火狐浏览器样式清除 */
    input[type='number'] {
      -moz-appearance: textfield;
    }
  }
}
</style>
